<template>
  <div id="#app">
    <v-app id="inspire">
      <!-- MENU -->
      <v-navigation-drawer v-model="drawer" app left v-if="['login','notfound'].indexOf($route.name) === -1">
        <v-list dense>
          <v-list-item-group>
            <v-list-item  @click="$router.push('/').catch((error) => {});">
              <v-list-item-action><v-icon>mdi-home</v-icon></v-list-item-action>
              <v-list-item-content><v-list-item-title>Inicio</v-list-item-title></v-list-item-content>
            </v-list-item>
            <v-list-group v-if="user.nivel_acceso !== 'administrador'" >  
              <template v-slot:activator>
                <v-list-item-action><v-icon>mdi-cash-multiple</v-icon>
                </v-list-item-action><v-list-item-title>Comprobación de gtos</v-list-item-title>
              </template>
              <v-list-item @click="$router.push('/Comprobaciones/Nueva').catch((error) => {});">
                <v-list-item-content >
                  <v-list-item-title><v-icon>mdi-circle-small</v-icon>Nueva</v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <v-list-item @click="$router.push('/Comprobaciones/New').catch((error) => {});" v-if="user.id_user=='c0c21717-6bb3-45ee-afd2-16c8d7c8a8db'">
                  <v-list-item-content >
                    <v-list-item-title> <v-icon>mdi-circle-small</v-icon>Captura Delegado</v-list-item-title>
                  </v-list-item-content>
              </v-list-item>
              <v-list-item @click="$router.push('/Comprobaciones/Solicitudes').catch((error) => {});">
                <v-list-item-content >
                  <v-list-item-title> <v-icon>mdi-circle-small</v-icon>Solicitudes Comprobantes</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>
            <v-list-item link v-if="user.nivel_acceso !== 'administrador'" @click="$router.push('/comprobaciones/historial').catch((error) => {});">
              <v-list-item-action>
                <v-icon>mdi-history </v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Seguimiento de Comprobaciones</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item link v-if="user.nivel_acceso !== 'administrador'" @click="$router.push('/comprobaciones/eliminadas').catch((error) => {});">
              <v-list-item-action>
                <v-icon>mdi-delete </v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Solicitudes Eliminadas</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item link v-if="user.nivel_acceso !== 'empleado' && user.nivel_acceso !== 'administrador'" @click="$router.push('/Comprobaciones/AutorizaGrupo').catch((error) => {});">
              <v-list-item-action>
                <v-icon>mdi-notebook</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title v-if="user.nivel_acceso !== 'tesorero'">Autorizaciones de gastos</v-list-item-title>
                <v-list-item-title v-if="user.nivel_acceso === 'tesorero'">Generación de Poliza</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item link v-if="user.nivel_acceso === 'tesorero'" @click="$router.push('/Comprobaciones/polizas').catch((error) => {});">
              <v-list-item-action>
                <v-icon>mdi-archive</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title v-if="user.nivel_acceso === 'tesorero'">Historico Poliza</v-list-item-title>
              </v-list-item-content>
            </v-list-item>            
            <v-list-item link v-if="user.nivel_acceso !== 'empleado' && user.nivel_acceso !== 'tesorero'" @click="$router.push('/Comprobaciones/BandejaHistorica').catch((error) => {});">
              <v-list-item-action>
                <v-icon>mdi-archive</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Bandeja histórica</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item link v-if="user.nivel_acceso !== 'empleado' && user.nivel_acceso !== 'tesorero' &&  user.nivel_acceso !== 'administrador'" @click="$router.push('/Reportes/Dashboard').catch((error) => {});">
              <v-list-item-action><v-icon>mdi-file-chart</v-icon></v-list-item-action>
              <v-list-item-content><v-list-item-title>Dashboard</v-list-item-title></v-list-item-content>
            </v-list-item>
            <v-list-item link v-if="user.nivel_acceso === 'supervisor' || user.nivel_acceso === 'administrador'" @click="$router.push('/Autorizaciones/Temporales').catch((error) => {});">
              <v-list-item-action> <v-icon>mdi-timer-sand-full </v-icon> </v-list-item-action>
              <v-list-item-content > <v-list-item-title>Autorizaciones temporales</v-list-item-title> </v-list-item-content>
            </v-list-item>
              <v-list-item link v-if="user.nivel_acceso === 'administrador'" @click="$router.push('/Delegar/CrearSolicitud').catch((error) => {});">
              <v-list-item-action> <v-icon>mdi-account-switch  </v-icon> </v-list-item-action>
              <v-list-item-content > <v-list-item-title>Admin. solicitudes</v-list-item-title> </v-list-item-content>
            </v-list-item>
            <v-list-item link v-if="user.nivel_acceso === 'administrador'" @click="$router.push('/Usuarios').catch((error) => {});">
              <v-list-item-action> <v-icon>mdi-account-box-multiple </v-icon> </v-list-item-action>
              <v-list-item-content > <v-list-item-title>Usuarios</v-list-item-title> </v-list-item-content>
            </v-list-item>

            <v-list-item link v-if="user.nivel_acceso === 'financiero' || user.nivel_acceso === 'tesorero'" @click="$router.push('/comprobaciones/rechazados').catch((error) => {});">
              <v-list-item-action> <v-icon>mdi-archive </v-icon> </v-list-item-action>
              <v-list-item-content > <v-list-item-title>Bandeja Rechazados</v-list-item-title> </v-list-item-content>
            </v-list-item>

            <v-list-group v-if="user.nivel_acceso === 'administrador'" >
              <template v-slot:activator>
                  <v-list-item-action> <v-icon>mdi-book-open-variant</v-icon></v-list-item-action>
                  <v-list-item-title>Catálogos</v-list-item-title>
              </template>
              <v-list-item @click="$router.push('/catalogos/centrocostos').catch((error) => {});">
                <v-list-item-action><v-icon>mdi-circle-small</v-icon></v-list-item-action>
                <v-list-item-content><v-list-item-title>Centro de Costos</v-list-item-title></v-list-item-content>
              </v-list-item>
              <v-list-item @click="$router.push('/catalogos/cuentas').catch((error) => {});">
                <v-list-item-action><v-icon>mdi-circle-small</v-icon></v-list-item-action>
                <v-list-item-content><v-list-item-title>Cuentas</v-list-item-title></v-list-item-content>
              </v-list-item>
              <v-list-item @click="$router.push('/catalogos/departamentos').catch((error) => {});">
                <v-list-item-action><v-icon>mdi-circle-small</v-icon></v-list-item-action>
                <v-list-item-content><v-list-item-title>Departamentos</v-list-item-title></v-list-item-content>
              </v-list-item>
              <v-list-item @click="$router.push('/catalogos/divisas').catch((error) => {});">
                <v-list-item-action><v-icon>mdi-circle-small</v-icon></v-list-item-action>
                <v-list-item-content><v-list-item-title>Divisas</v-list-item-title></v-list-item-content>
              </v-list-item>
              <v-list-item @click="$router.push('/catalogos/puestos').catch((error) => {});">
                <v-list-item-action><v-icon>mdi-circle-small</v-icon></v-list-item-action>
                <v-list-item-content><v-list-item-title>Puestos</v-list-item-title></v-list-item-content>
              </v-list-item> 
            </v-list-group>   
          </v-list-item-group>
        </v-list>
      </v-navigation-drawer>
      <!-- BARRA SUPERIOR DE LA APP -->
      <v-app-bar app color="#1C2546" dark >
        <v-app-bar-nav-icon  @click.stop="drawer = !drawer"  v-if="['login','notfound'].indexOf($route.name) === -1"/>
        <v-toolbar-title v-if="['login','notfound'].indexOf($route.name) === -1">Bienvenido, {{ user.nombre }}</v-toolbar-title>
        <v-spacer />
        <v-toolbar-title>Travel & Employee Expenses</v-toolbar-title>
        <v-btn icon v-if="['login','notfound'].indexOf($route.name) === -1" @click="open_logout"> <v-icon>mdi-exit-to-app</v-icon> </v-btn>
      </v-app-bar>
      <!-- CONTENIDO DE LA APP -->
      <v-content>
        <router-view></router-view>
      </v-content>
      <!-- BARRA INFERIOR DE LA APP -->
      <v-footer color="#f8f9fd" app >
        <v-spacer />
        <span class="black--text">&copy; 2025 Kuantik </span>
      </v-footer>
      <!-- CONFIRMACION DE LOGOUT -->
      <v-dialog v-model="ventana_logout" max-width="590">
        <v-card>
          <v-card-title><span class="headline">Cerrar Sesión</span></v-card-title>
          <v-card-text>
              ¿Estas seguro de cerrar sesión?
          </v-card-text>
          <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="ventana_logout = false">Cancelar</v-btn>
              <v-btn color="blue darken-1" text @click="logout">Confirmar</v-btn>
          </v-card-actions>
        </v-card> 
      </v-dialog>
    </v-app>
  </div>
</template>
<script>
  import 'babel-polyfill';
  export default {
    name: 'App',
    props: {
      source: String,
    },
    data: () => ({
      drawer: null,
      ventana_logout: false,
      admins: [
        ['Management', 'people_outline'],
        ['Settings', 'settings'],
      ],
      cruds: [
        ['Create', 'add'],
        ['Read', 'insert_drive_file'],
        ['Update', 'update'],
        ['Delete', 'delete'],
      ],
      comprobaciones: [
        ['Nueva'],
        ['Comprobaciones de solicitudes']
      ]
    }),
    computed: {
        user() {
          return this.$store.state.user;
        }
    },
    methods: {
      logout(){
        this.$store.commit('setUser',{});
        this.$store.commit('setToken','');
        this.$router.push('/login');
        this.ventana_logout = false;
      },
      open_logout(){
        this.ventana_logout = true;
      }
    }
  }
</script> 
<style>
.v-application--is-ltr .v-list-item__action:last-of-type:not(:only-child), .v-application--is-ltr .v-list-item__avatar:last-of-type:not(:only-child), .v-application--is-ltr .v-list-item__icon:last-of-type:not(:only-child){
  margin-left: -17px !important;
}
.mdi-menu-down::before {
    content: ''!important;
}
</style>
